declare const process: {
  env: Record<string, string | undefined>;
};

export const env = {
  environment: process.env.VUE_APP_ENVIRONMENT,
  appName: process.env.VUE_APP_NAME || '',
  apiUrl: process.env.VUE_APP_API_URL,
  apiAuthUrl: process.env.VUE_APP_API_AUTH_URL,
  apiVersion: '1.0',
  i18nLocale: process.env.VUE_APP_I18N_LOCALE,
  i18nFallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE,
  appInsights: process.env.VUE_APP_INSIGHTS,
  auth: {
    clientId: process.env.VUE_APP_CLIENTID || '',
    authority: process.env.VUE_APP_AUTHORITY || '',
    redirectUri: (() => {
      const configuredRedirectUri = process.env.VUE_APP_AUTH_REDIRECT_URI || '';

      if (configuredRedirectUri) {
        return configuredRedirectUri;
      }

      if (typeof window !== 'undefined' && window.location?.origin) {
        return window.location.origin;
      }

      return '';
    })(),
    consentScopes: process.env.VUE_APP_AUTH_CONSENT_SCOPES || '',
    responseType: process.env.VUE_APP_AUTH_RESPONSE_TYPE || ''
  },
  topLanguages: process.env.VUE_APP_TOPLANGUAGES
};
